import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { NgxPaginationModule } from 'ngx-pagination';

import { ContactoService } from './services/contacto.service';
import { PublicacionService } from './services/publicacion.service';
import { ServicioService } from './services/servicio.service';
import { ActividadService } from './services/actividad.service';
import { PeliculaService } from './services/pelicula.service';
import { MaratonService } from './services/maraton.service';
import { EspectaculoService } from './services/espectaculo.service';
import { ProgramacionService } from './services/programacion.service';

import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { ContactoComponent } from './contacto/contacto.component';
import { ServiciosComponent } from './servicios/servicios.component';
import { SalonesComponent } from './servicios/salones/salones.component';
import { ActividadesComponent } from './actividades/actividades.component';
import { FutbolComponent } from './actividades/futbol/futbol.component';
import { CineComponent } from './cine/cine.component';
import { EspectaculosComponent } from './espectaculos/espectaculos.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { NoticiaComponent } from './noticia/noticia.component';
import { ServicioComponent } from './servicio/servicio.component';
import { ActividadComponent } from './actividad/actividad.component';
import { PeliculaComponent } from './pelicula/pelicula.component';
import { MaratonComponent } from './maraton/maraton.component';
import { EspectaculoComponent } from './espectaculo/espectaculo.component';
import { MaratonesComponent } from './maratones/maratones.component';
import { ProgramacionComponent } from './programacion/programacion.component';
import { PeliculasComponent } from './peliculas/peliculas.component';



@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    ContactoComponent,
    ServiciosComponent,
    SalonesComponent,
    ActividadesComponent,
    FutbolComponent,
    CineComponent,
    EspectaculosComponent,
    NoticiasComponent,
    NoticiaComponent,
    ServicioComponent,
    ActividadComponent,
    PeliculaComponent,
    MaratonComponent,
    EspectaculoComponent,
    MaratonesComponent,
    ProgramacionComponent,
    PeliculasComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule
  ],
  providers: [
    ContactoService,
    PublicacionService,
    ServicioService,
    ActividadService,
    PeliculaService,
    MaratonService,
    EspectaculoService,
    ProgramacionService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
